exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".auto-dialer--22gtfnKO0j7rl4kN5fLpym {\n  border-bottom: 1px dotted #c7e7f1;\n  border-top: 1px dotted #c7e7f1;\n  margin: 32px 0 16px 0;\n  padding: 12px 0;\n}\n\n.auto-dialer--J7QuBZAf52UdJ2K2yJUY {\n  display: inline-block;\n  margin: 0 5px;\n}\n\n.auto-dialer--2lDIQYxNbD1zGK1nt5s4LN {\n  margin-bottom: 12px;\n}\n", ""]);

// exports
exports.locals = {
	"helpContainer": "auto-dialer--22gtfnKO0j7rl4kN5fLpym",
	"helpContainer": "auto-dialer--22gtfnKO0j7rl4kN5fLpym",
	"divider": "auto-dialer--J7QuBZAf52UdJ2K2yJUY",
	"divider": "auto-dialer--J7QuBZAf52UdJ2K2yJUY",
	"technicalIssues": "auto-dialer--2lDIQYxNbD1zGK1nt5s4LN",
	"technicalIssues": "auto-dialer--2lDIQYxNbD1zGK1nt5s4LN"
};